import { reactive } from 'vue'

// Stato condiviso fra i componenti globali del totem (App.vue) e il checkout,
// che non hanno un genitore in comune da cui passarselo.
export const kioskSession = reactive({
  // Nome del socio che sta pagando; vuoto se nessuno è loggato.
  userName: '',
  // Secondi che mancano all'annullamento per inattività; null quando il timer non gira.
  idleSecondsLeft: null,
  // True mentre il Cashmatic sta incassando: né il timer né «Chiudi» devono
  // interrompere un pagamento in corso.
  paymentActive: false,
  // Pagamento con carta in corso sul POS: stessa regola di paymentActive (niente timeout, niente «Chiudi»).
  cardActive: false,
  // Cosa mostrare al socio mentre paga sul POS.
  card: { amount: 0, message: '' },
})

/** True se il Cashmatic o il POS stanno incassando: nulla deve interrompere un pagamento in corso. */
export const paymentBusy = () => kioskSession.paymentActive || kioskSession.cardActive
